import { createAsyncThunk } from '@reduxjs/toolkit';
import {
	ChartType,
	ReportByIdApiResponse,
	ReportConfig,
	ReportsMetaDataResponse,
} from 'src/types/reportingTypes';
import { pushToast } from '../reportingSlice';
import { fetchReportsMetaData } from './fetchReportsMetaData';
import { RootState } from 'src/redux/store';

export const updateReportById = createAsyncThunk<
	string,
	UpdateReportByIdPayload,
	{ rejectValue: string; state: RootState }
>(
	'reporting/updateReportById',
	async (
		{ api, id, reportId, reqPayload, message },
		{ dispatch, rejectWithValue, getState },
	) => {
		try {
			const state = getState();
			const activeGraph = state.reporting.activeGraph;
			reqPayload.config = { ...reqPayload.config, chartType: activeGraph as ChartType };
			
			const response = await api.updateUnifiedReportById(
				id,
				reportId,
				reqPayload,
			);
			dispatch(fetchReportsMetaData({ api, id }));
			dispatch(
				pushToast({
					type: 'success',
					message,
				}),
			);
			return response.data.name;
		} catch (error) {
			const message =
				error instanceof Error
					? error.message
					: 'An unexpected error occurred';
			dispatch(
				pushToast({
					type: 'error',
					message:
						'Error on updating report. Please try again after some time.',
				}),
			);
			return rejectWithValue(message);
		}
	},
);

export type UpdateReportByIdRequestType = {
	accountId: string;
	dataType: string;
	config: ReportConfig;
	page: number;
	size: number;
	reportId: string;
	name: string;
};

type UpdateReportByIdPayload = {
	api: {
		updateUnifiedReportById: (
			id: string,
			reportId: string,
			reqPayload: UpdateReportByIdRequestType,
		) => Promise<ReportByIdApiResponse>;
		getUnifiedReportingMetaData: (
			id: string,
		) => Promise<ReportsMetaDataResponse>;
	};
	id: string;
	reportId: string;
	reqPayload: UpdateReportByIdRequestType;
	message: string;
};
